import React from 'react';
import { ListItemText } from '@mui/material';
import { List, ListItem, ListItemIcon, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import { FiberManualRecord } from '@mui/icons-material';
import { grey } from '@mui/material/colors';
import { isString } from 'lodash';
import { RoundedDialog, StandardDialogActions } from '../Components';

export default function SelectedOptionsDialog({ options, open, onClose, withImages }) {
  if (!Array.isArray(options)) return null;

  return (
    <RoundedDialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Selected</DialogTitle>
      <DialogContent>
        {withImages ? (
          <Grid container>
            {options.map((option, index) => (
              <Grid item container xs={6} sx={{ p: 0.25 }} key={index}>
                <Grid item container alignContent={'flex-start'}>
                  {option.image && (
                    <Grid
                      item
                      container
                      component={'img'}
                      src={option.image}
                      alt={option.text}
                      sx={{ maxWidth: '100%' }}
                    />
                  )}
                </Grid>
                <Grid item container justifyContent={'center'} sx={{ textAlign: 'center', pt: 1, mt: 'auto' }}>
                  <Typography>{option.text}</Typography>
                </Grid>
              </Grid>
            ))}
          </Grid>
        ) : (
          <List>
            {options.map((option, i) => (
              <ListItem key={i}>
                {option.image ? (
                  <Grid
                    item
                    component={'img'}
                    src={option.image}
                    alt="img"
                    sx={{ maxWidth: 40, maxHeight: 40, mr: 1 }}
                  />
                ) : (
                  <ListItemIcon>
                    <FiberManualRecord style={{ color: grey[500] }} />
                  </ListItemIcon>
                )}

                <ListItemText primary={isString(option) ? option : isString(option.text) ? option.text : ''} />
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
      <StandardDialogActions onClose={onClose} />
    </RoundedDialog>
  );
}
